'use client';

import { css } from '@bts-web/utils-style-engine';
import { useRouter } from 'next/navigation';
import { ButtonBase } from '../../common/components';

export const SeeAllOrdersButton = ({
  seeAllTranslation,
}: {
  seeAllTranslation: string;
}) => {
  const router = useRouter();

  return (
    <ButtonBase
      className={css({
        width: 'auto',
        '& > span': {
          color: 'neutrals.text_primary',
          fontSize: 'body.medium_medium',
          fontWeight: 'body.medium_medium',
          lineHeight: 'body.medium_medium',
          textDecorationLine: 'underline',
          textDecorationStyle: 'solid',
          textDecorationSkipInk: 'none',
          textDecorationThickness: 'auto',
        },
      })}
      noPadding
      visual="ghost"
      onClick={() => {
        router.push('/orders');
      }}
    >
      <span>{seeAllTranslation}</span>
    </ButtonBase>
  );
};
